export default{
  month: 'Bulan',
  year: 'Tahun',
  totalPayout: 'Total Dana Keluar',
  show: 'Menampilkan',
  from: 'dari',
  date: 'Tanggal',
  status: 'Status',
  type: 'Tipe',
  transaction: 'Transaksi',
  shippingCost: 'Biaya Ongkir',
  dataNotAvailable: 'Data tidak Tersedia'
}